import React from 'react';
import { Grid } from 'semantic-ui-react';
import CalendarIntegrations from './CalendarIntegrations';
import CalendarPreferences from './CalendarPreferences';
import { useSelector } from 'react-redux';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

const Calendar = () => {
    const active = useSelector((state) =>
        state.user.userProfile.active
    )
    return (
         <RestrictedView userPermission={USER_PERMISSIONS.USER_PROFILE_PREFERENCES_VIEW} type="restricted" userRestrict>
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <CalendarIntegrations active={active} />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        <CalendarPreferences active={active}/>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </RestrictedView>
    )
};

export default Calendar;
